import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import 'react-dropdown-tree-select/dist/styles.css'


class Trash extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

   
    render() {
       
        const { errors } = this.state;
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <h3 className="xp-page-title">Trash</h3>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li class="breadcrumb-item active">Trash</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xp-contentbar p-30">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card m-b-30">
                                <div className="card-header bg-primary">
                                    <h5 className="card-title text-white">Trash</h5>
                                    
                                </div>
                                <div className="card-body">
                                    <h5 className="text-center">Form Under Development.</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Trash
